import { coreService } from "../../../services";

export interface RssFeedEpisode {
  title: string;
  enclosure_url: string;
  mime_type: string;
  pub_date?: string;
  duration_in_seconds?: number;
  image_url?: string;
  guid?: string;
}

export interface RssFeed {
  podcast_title: string;
  podcast_image_url?: string;
  episodes: RssFeedEpisode[];
}

const getRssFeedEpisodes = async (feedUrl: string): Promise<RssFeed> => {
  const response = await coreService.httpClient.get(
    `/episodes/rss-feed-episodes?url=${encodeURIComponent(feedUrl)}`,
    { withCredentials: true },
  );
  return response.data;
};

const importFromRss = async (payload: {
  enclosure_url: string;
  name: string;
  project_id: string;
}): Promise<{ episode_id: string }> => {
  const response = await coreService.httpClient.post(
    "/episodes/import-from-rss",
    payload,
    true,
  );
  return response.data;
};

export { getRssFeedEpisodes, importFromRss };
